/* dwl-smart-upsell.js — klik-afhandeling voor de slimme suggesties (cart drawer)
 * en het "Maak er 3 van"-blok op de productpagina.
 * Gedelegeerd op document: blijft werken nadat cart-bundle.js de drawer vervangt.
 * De mix & match-korting (3+ −10%, 5+ −15%) regelt Shopify zelf; hier alleen toevoegen.
 */
(function () {
  'use strict';
  if (window.__dwlSmartUpsell) return;
  window.__dwlSmartUpsell = true;


  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  /* Drawer zelf verversen: body en footer vervangen door verse HTML van de server.
     Onafhankelijk van cart-bundle.js, zodat het nooit kan blijven hangen. */
  function drawerSectionId() {
    if (window.DWLCart && typeof window.DWLCart.drawerSectionId === 'function') {
      try { return window.DWLCart.drawerSectionId(); } catch (e) {}
    }
    var d = document.querySelector('cart-drawer');
    var w = d && d.closest('.shopify-section');
    return w && w.id ? w.id.replace('shopify-section-', '') : null;
  }
  function withTimeout(p, ms) {
    return Promise.race([p, new Promise(function (r) { setTimeout(r, ms); })]);
  }
  function refresh() {
    var sid = drawerSectionId();
    var drawer = document.querySelector('cart-drawer');
    if (!sid || !drawer) return Promise.resolve();
    var sections = fetch(root() + '?sections=' + encodeURIComponent(sid), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
    var cart = fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
    return withTimeout(Promise.all([sections, cart]).then(function (res) {
      var html = res[0] && res[0][sid];
      if (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('cart-drawer');
        if (fresh) {
          ['.cart-drawer-body', '.cart-drawer-footer'].forEach(function (sel) {
            var a = drawer.querySelector(sel), b = fresh.querySelector(sel);
            if (a && b) a.innerHTML = b.innerHTML;
          });
          drawer.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
        }
      }
      var c = res[1];
      if (c && typeof c.item_count === 'number') {
        document.querySelectorAll('.cart-count').forEach(function (el) { el.textContent = c.item_count; });
      }
      document.dispatchEvent(new CustomEvent('dwl:cart-updated', { detail: c }));
    }), 4000).catch(function () {});
  }

  /* Eigen /cart/add.js + daarna de drawer opnieuw laten renderen. Bewust niet via
     DWLCart.add: die animeert naar het winkelmandje en ververst de open drawer niet altijd. */
  function add(items) {
    return fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw j; return j; });
    }).then(refresh);
  }

  function setBusy(btn, on) {
    if (btn) { btn.disabled = on; btn.classList.toggle('is-busy', on); }
  }

  document.addEventListener('click', function (e) {
    /* Cart drawer: één suggestie toevoegen */
    var one = e.target.closest('[data-dsu-add]');
    if (one) {
      e.preventDefault();
      if (one.disabled) return;
      setBusy(one, true);
      var card = one.closest('.dsu__card');
      if (card) card.classList.add('is-added');
      var vid = parseInt(one.getAttribute('data-dsu-add'), 10);
      add([{ id: vid, quantity: 1, properties: { _upsell: 'cart' } }])
        .catch(function (err) {
          if (card) card.classList.remove('is-added');
          if (window.console) console.warn('[dwl-smart-upsell]', err);
        })
        .then(function () { setBusy(one, false); });
      return;
    }

    /* Complete set (Crypto/Jurassic): losse eenden ruilen voor het set-product */
    var sw = e.target.closest('[data-dfs-swap]');
    if (sw) {
      e.preventDefault();
      if (sw.disabled) return;
      setBusy(sw, true);
      var setVid = parseInt(sw.getAttribute('data-dfs-swap'), 10);
      var members = (sw.getAttribute('data-members') || '').split(',');
      fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var updates = {}, done = {};
          cart.items.forEach(function (l) {
            var p = l.properties || {};
            if (p._gift || done[l.handle] || members.indexOf(l.handle) === -1) return;
            done[l.handle] = true;
            updates[l.key] = l.quantity - 1;
          });
          return fetch(root() + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: setVid, quantity: 1, properties: { _upsell: 'full-set' } }] })
          }).then(function (r) { if (!r.ok) throw r; return r.json(); }).then(function () {
            if (!Object.keys(updates).length) return null;
            return fetch(root() + 'cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ updates: updates })
            });
          });
        })
        .then(refresh)
        .catch(function (err) { if (window.console) console.warn('[dwl-smart-upsell]', err); return refresh(); })
        .then(function () { setBusy(sw, false); });
      return;
    }

    /* Productpagina: "Maak er 3 van" — aangevinkte eenden samen toevoegen */
    var trio = e.target.closest('[data-dmt-add]');
    if (trio) {
      e.preventDefault();
      if (trio.disabled) return;
      var box = trio.closest('.dmt');
      if (!box) return;
      var items = [];
      box.querySelectorAll('input[data-dmt-variant]:checked').forEach(function (cb) {
        items.push({ id: parseInt(cb.getAttribute('data-dmt-variant'), 10), quantity: 1, properties: { _upsell: 'product-trio' } });
      });
      if (!items.length) return;
      setBusy(trio, true);
      add(items)
        .catch(function (err) { if (window.console) console.warn('[dwl-smart-upsell]', err); })
        .then(function () {
          setBusy(trio, false);
          if (window.DWLCart && typeof window.DWLCart.openDrawer === 'function') window.DWLCart.openDrawer();
        });
    }
  });

  /* Productpagina: 3 of 5 kiezen (stapelkorting) */
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-dmt-tier]');
    if (!tab) return;
    e.preventDefault();
    var box = tab.closest('.dmt');
    if (!box) return;
    var tier = parseInt(tab.getAttribute('data-dmt-tier'), 10);
    box.querySelectorAll('input[data-dmt-variant]').forEach(function (c, i) { c.checked = i < tier; });
    updateTrio(box);
  });

  function updateTrio(box) {
    var sum = 0, n = 0;
    box.querySelectorAll('input[data-dmt-variant]:checked').forEach(function (c) {
      sum += parseInt(c.getAttribute('data-price'), 10) || 0;
      n++;
    });
    var pct = n >= 5 ? 0.15 : (n >= 3 ? 0.10 : 0);
    var total = Math.round(sum * (1 - pct));
    var fmt = function (cents) {
      return '€' + (cents / 100).toFixed(2).replace('.', ',');
    };
    var priceEl = box.querySelector('[data-dmt-total]');
    var wasEl = box.querySelector('[data-dmt-was]');
    var countEl = box.querySelector('[data-dmt-count]');
    if (priceEl) priceEl.textContent = fmt(total);
    if (wasEl) { wasEl.textContent = pct ? fmt(sum) : ''; }
    if (countEl) countEl.textContent = n;
    var btn = box.querySelector('[data-dmt-add]');
    if (btn) btn.disabled = n === 0;
    /* tabs, kop en hint meebewegen */
    var five = n >= 5;
    box.querySelectorAll('[data-dmt-tier]').forEach(function (t) {
      t.classList.toggle('is-on', (t.getAttribute('data-dmt-tier') === '5') === five);
    });
    /* De kop is het volgende doel, niet de huidige stand: bij 4 eenden mik je op 5. */
    var title = box.querySelector('[data-dmt-title]');
    var allN = box.querySelectorAll('input[data-dmt-variant]').length;
    var aimFive = n >= 5 || (n >= 4 && allN >= 5);
    if (title && box.getAttribute('data-t3')) title.textContent = box.getAttribute(aimFive ? 'data-t5' : 'data-t3');
    var hint = box.querySelector('[data-dmt-hint]');
    if (hint && box.getAttribute('data-hint')) {
      var tpl = box.getAttribute('data-hint') || '';
      var all = box.querySelectorAll('input[data-dmt-variant]').length;
      if (n >= 5) hint.textContent = (box.getAttribute('data-max') || '') + ': −15%';
      else if (n >= 3) hint.textContent = all >= 5 ? tpl.replace('[n]', 5 - n).replace('[p]', '−15%') : '';
      else hint.textContent = tpl.replace('[n]', 3 - n).replace('[p]', '−10%');
    }
  }

  /* Productpagina: totaalprijs bijwerken als er een vinkje verandert */
  document.addEventListener('change', function (e) {
    var cb = e.target.closest('input[data-dmt-variant]');
    if (!cb) return;
    var box = cb.closest('.dmt');
    if (box) updateTrio(box);
  });
})();
